import React from 'react'
import Avatar from './Avatar'
import Balls from './Balls'
import { UserStore } from '../store/userStore'
import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'

interface IProps {
  className?: string
  small?: boolean
  hasLink?: boolean
}

const UserShortInfo = observer((props: IProps) => {
  const WrapperTag = props.hasLink ? Link : 'div'

  return (
    <div
      className={`user-short-info ${props.className ?? ''} ${
        props.small ? '_small' : ''
      }`.trim()}
    >
      <WrapperTag
        // @ts-expect-error If tag is not Link, prop to is unnecessary
        to={props.hasLink ? '/profile' : undefined}
        className="user-short-info__wrapper"
      >
        <div className={'user-short-info__avatar'}>
          <Avatar
            tag={'span'}
            size={props.small ? 'md' : 'lg'}
            url={UserStore.data.avatarUrl}
          ></Avatar>
        </div>
        <div className="user-short-info__name">
          {UserStore.data.name} {UserStore.data.lastName}
        </div>
      </WrapperTag>
      {!props.small && (
        <div className="user-short-info__items">
          {UserStore.data.role && (
            <p className={'text-body-small text-secondary-color'}>
              {UserStore.data.role}
            </p>
          )}
          {UserStore.data.balls !== undefined ||
          UserStore.data.coins !== undefined ? (
            <div className="user-short-info__balls text-secondary-color">
              {UserStore.data.balls !== undefined ? (
                <Balls
                  balls={UserStore.data.balls}
                  icon="/i/svg/rating.svg"
                ></Balls>
              ) : null}
              {UserStore.data.coins !== undefined ? (
                <Balls
                  balls={UserStore.data.coins}
                  icon="/i/svg/coin.svg"
                ></Balls>
              ) : null}
            </div>
          ) : null}
          {/*<Btn to={'/profile/edit'} small text>*/}
          {/*  <ReactSVG wrapper={'span'} src={'/i/svg/pencil.svg'}></ReactSVG>*/}
          {/*  <span>Редактировать</span>*/}
          {/*</Btn>*/}
        </div>
      )}
    </div>
  )
})

export default UserShortInfo
